import React, {useEffect, useState} from 'react'
import {Link, useHistory} from "react-router-dom";
import {ArrowBackIcon, DeleteIcon, DownloadIcon} from "~/Components/Icons/Icons";
import {adminHttp} from "~/Admin/services/http";
import {connect} from "react-redux";
import AdminItineraryFileUploader from "./AdminItineraryFileUploader";
import {humanFileSize} from "~/helpers/utils";
import Moment from "react-moment";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import useEffectSkipFirst from '../../../Hooks/useEffectSkipFirst';

const AdminViewItinerary = ({event, match, ...props}) => {

    const [itinerary, setItinerary] = useState(null);
    const endpoint = '/events/' + event.id + '/itineraries/' + match.params.id;

    const history = useHistory();

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setItinerary(res.data);
            });
    };

    const handleDeleteDocument = (id) => {
        adminHttp
            .delete(endpoint + '/documents/' + id)
            .then(res => loadData());
    };

    useEffectSkipFirst(() => {
        history.push('/guests/registration');
    }, [event]);

    useEffect(() => {
        loadData()
    }, []);


    if (!itinerary) {
        return <></>
    }

    return (
        <div>
            <Link to="/event/itinerary" className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2"/>
                Back
            </Link>

            <div className="row">
                <div className="col-12">
                    <h2>Itinerary Documents</h2> <small>{itinerary.wave?.name || '-'} / {itinerary.package?.name || '-'}</small>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3 className="mb-2">File Upload</h3>
                    <p className="mb-4">Upload your itinerary documents</p>
                    <AdminItineraryFileUploader itinerary={itinerary} onUploaded={loadData}/>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3 className="text-primary mb-4">Uploaded Documents</h3>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Size</th>
                            <th scope="col">Date</th>
                            <th scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {itinerary.documents?.map((doc) => (
                            <tr key={doc.id}>
                                <td>{doc.name}</td>
                                <td>{humanFileSize(doc.size)}</td>
                                <td><Moment format="DD/MM/YYYY h:mm:ss a" date={doc.created_at}/></td>
                                <td>
                                    <a className="d-inline cursor-pointer" href={doc.download_url}>
                                        <DownloadIcon classes="d-inline" />
                                    </a>
                                    <ConfirmedLink className="d-inline cursor-pointer" onClick={(e) => handleDeleteDocument(doc.id)}>
                                        <DeleteIcon classes="d-inline" />
                                    </ConfirmedLink>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewItinerary);
